import useSWRImmutable from 'swr/immutable'
import { Parameter$getBrandsPopular } from '~/api/gen'
import { fetchGetBrandsPopular } from '../lib/fetchGetBrandsPopular'
import { getBrandsPopularKey } from '../lib/getBrandsPopularKey'

export const usePopularBrands = (parameter: Parameter$getBrandsPopular) => {
  const key = getBrandsPopularKey(parameter)
  return useSWRImmutable(key, fetchGetBrandsPopular)
}
